import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useState, useEffect } from "react";
import { addEnquiry } from "./api/enquiryApi";

const GAUGE_STAGES = ["COLLECTING", "FILTERING", "SUPPLYING", "DELIVERED"];

function App() {

  const [form, setForm] = useState({
    emailormobile: "",
    name: "",
    type: "",
    message: ""
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [navOpen, setNavOpen] = useState(false);
  const [gaugeIndex, setGaugeIndex] = useState(0);

  // Mirrors the old vanilla-JS mobile nav toggle logic
  const handleNavToggle = () => {
    setNavOpen((prev) => !prev);
  };

  const closeNav = () => {
    setNavOpen(false);
  };

  // Mirrors the old gaugeReadout cycling-text interval
  useEffect(() => {
    const id = setInterval(() => {
      setGaugeIndex((prev) => (prev + 1) % GAUGE_STAGES.length);
    }, 1750);
    return () => clearInterval(id);
  }, []);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    console.log(form)
    e.preventDefault();
    setError("");
    setSuccess("");

    const requestObj = {
      name: form.name,
      emailormobile: form.emailormobile,
      type: form.type,
      message: form.message
    };

    try {
      setLoading(true);
      await addEnquiry(requestObj);
      setSuccess("Enquiry added successfully");
      setForm({
        emailormobile: "",
        name: "",
        type: "",
        message: ""
      });
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <header>
        <div class="callbar">
          <a href="tel:+918527127240">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.362 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.338 1.85.573 2.81.7A2 2 0 0 1 22 16.92z" /></svg>
            85271 27240 / 81713 47666
          </a>
        </div>
        <nav class="wrap">
          <div class="logo"><span class="mark" style={{ marginRight: '8px' }}></span><span class="l-oil">OIL</span><span class="l-chakra">CHAKRA</span></div>
          <div class={`nav-links${navOpen ? " open" : ""}`} id="navLinks">
            <a href="#how-it-works" onClick={closeNav}>How it works</a>
            <a href="#for-whom" onClick={closeNav}>Sell / Buy</a>
            <a href="#standards" onClick={closeNav}>Our Standards</a>
            <a href="#coverage" onClick={closeNav}>Coverage</a>
          </div>
          <div class="nav-right">
            <a href="#contact" class="nav-cta">Get a Rate →</a>
            <button
              class={`nav-toggle${navOpen ? " open" : ""}`}
              id="navToggle"
              aria-label="Toggle menu"
              aria-expanded={navOpen}
              aria-controls="navLinks"
              onClick={handleNavToggle}
              type="button"
            >
              <span></span><span></span><span></span>
            </button>
          </div>
        </nav>
      </header>

      <section class="hero">
        <div class="wrap hero-grid">
          <div>
            <div class="eyebrow">Used Cooking Oil Aggregator</div>
            <h1 class="hero-title">Every drop <br /> goes <span class="accent">somewhere.</span></h1>
            <p class="hero-sub">We collect used cooking oil from restaurants, hotels and kitchens, and supply it — tested, filtered, and traceable — to biodiesel and oleochemical manufacturers. One cycle, kept clean.</p>
            <div class="hero-ctas">
              <a href="#contact" class="btn btn-primary">I want to sell UCO ↗</a>
              <a href="#contact" class="btn btn-ghost">I want to buy UCO ↗</a>
            </div>
            <div class="hero-stats">
              <div>
                <div class="stat-num">100%</div>
                <div class="stat-label">Diverted from re-frying</div>
              </div>
              <div>
                <div class="stat-num">&lt;25%</div>
                <div class="stat-label">TPC threshold we test to</div>
              </div>
              <div>
                <div class="stat-num">0</div>
                <div class="stat-label">Oil returned to food chain</div>
              </div>
            </div>
          </div>

          <div class="wheel-wrap-outer">
            <div class="wheel-stage">
              <svg class="wheel-ring" viewBox="0 0 400 400" xmlns="http://www.w3.org/2000/svg">
                <circle cx="200" cy="200" r="188" fill="none" stroke="#2A3D2A" stroke-width="1" />
                <circle cx="200" cy="200" r="150" fill="none" stroke="#2A3D2A" stroke-width="1" stroke-dasharray="2 6" />
                <g fill="none" stroke-width="14" stroke-linecap="butt">
                  <path d="M200,50 A150,150 0 0 1 350,200" stroke="#C9962C" />
                  <path d="M350,200 A150,150 0 0 1 200,350" stroke="#B5511F" />
                  <path d="M200,350 A150,150 0 0 1 50,200" stroke="#7A8F6C" />
                  <path d="M50,200 A150,150 0 0 1 200,50" stroke="#E8B84B" />
                </g>
                <circle cx="200" cy="200" r="70" fill="#1B2B21" stroke="#3A4E38" stroke-width="1" />
              </svg>
              <div class="wheel-center">
                <div class="cnum">OIL</div>
                <div class="clabel">CHAKRA</div>
              </div>
              <div class="wheel-tag t-top">COLLECT</div>
              <div class="wheel-tag t-right">FILTER</div>
              <div class="wheel-tag t-bottom">SUPPLY</div>
              <div class="wheel-tag t-left">REFINE</div>
              {/* <div class="wheel-gauge" id="gaugeReadout">{GAUGE_STAGES[gaugeIndex]}</div> */}
            </div>
          </div>
        </div>
      </section>

      <section class="section" id="for-whom">
        <div class="wrap">
          <div class="section-head">
            <div class="eyebrow">Two Sides, One Loop</div>
            <h2 class="section-title">Who OilChakra works with</h2>
            <p class="section-desc">We sit between the kitchens that generate used oil and the manufacturers who need it as feedstock — handling collection, quality testing, and paperwork on both ends.</p>
          </div>
          <div class="audience-grid">
            <div class="audience-card">
              <span class="tag">For Restaurants & Hotels</span>
              <h3>Sell your UCO</h3>
              <p>Stop paying to dispose of used oil, or worse, letting it go down the drain. We collect on a schedule and pay per litre.</p>
              <ul>
                <li>Free scheduled pickup, no minimum order</li>
                <li>Paid per litre on collection, transparent weighing</li>
                <li>Written pickup receipt every time</li>
                <li>Sealed containers provided, no mess at your site</li>
              </ul>
            </div>
            <div class="audience-card">
              <span class="tag">For Biodiesel & Oleochemical Units</span>
              <h3>Buy quality-tested UCO</h3>
              <p>A consistent, documented feedstock supply — sourced directly from restaurants and hotels, never re-blended with virgin oil.</p>
              <ul>
                <li>FFA and moisture data shared with every batch</li>
                <li>Bulk and rate-contract supply available</li>
                <li>Traceable sourcing, batch by batch</li>
                <li>Flexible delivery — tanker or drums</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section class="section section-alt" id="how-it-works">
        <div class="wrap">
          <div class="section-head">
            <div class="eyebrow">The Process</div>
            <h2 class="section-title">From fryer to feedstock, in four steps</h2>
          </div>
          <div class="process-list">
            <div class="process-row">
              <div class="process-num">01</div>
              <div>
                <div class="process-name">Collect</div>
                <div class="process-detail">Our team picks up used oil directly from your kitchen in sealed containers, on a schedule that matches your volume.</div>
              </div>
              <div class="process-meta">ON-SITE</div>
            </div>
            <div class="process-row">
              <div class="process-num">02</div>
              <div>
                <div class="process-name">Test & Filter</div>
                <div class="process-detail">Every batch is checked for Total Polar Compounds and moisture, then filtered and settled to remove food particles and water.</div>
              </div>
              <div class="process-meta">QUALITY CHECK</div>
            </div>
            <div class="process-row">
              <div class="process-num">03</div>
              <div>
                <div class="process-name">Store</div>
                <div class="process-detail">Oil is held in a dedicated storage yard — segregated by batch and never mixed with fresh or edible-grade oil.</div>
              </div>
              <div class="process-meta">AGGREGATION</div>
            </div>
            <div class="process-row">
              <div class="process-num">04</div>
              <div>
                <div class="process-name">Supply</div>
                <div class="process-detail">Bulk delivery to biodiesel and oleochemical manufacturers, with full batch documentation.</div>
              </div>
              <div class="process-meta">DELIVERY</div>
            </div>
          </div>
        </div>
      </section>

      <section class="section" id="standards">
        <div class="wrap">
          <div class="section-head">
            <div class="eyebrow">Why It's Handled Right</div>
            <h2 class="section-title">Built on responsible sourcing practices</h2>
            <p class="section-desc">Used cooking oil deserves careful handling. Here's how we approach collection, quality, and where the oil actually goes.</p>
          </div>
          <div class="compliance-grid">
            <div class="compliance-card">
              <div class="icon">R</div>
              <h4>Responsible collection</h4>
              <p>We collect only for non-food repurposing — biodiesel, soap, and lubricant production — and keep a record of every transaction.</p>
            </div>
            <div class="compliance-card">
              <div class="icon">Q</div>
              <h4>Quality-tested at intake</h4>
              <p>Every batch is checked against the 25% Total Polar Compound threshold before it enters our storage, so quality is documented from day one.</p>
            </div>
            <div class="compliance-card">
              <div class="icon">D</div>
              <h4>Documented disposal</h4>
              <p>Partner kitchens get a written pickup record every time — useful for their own internal recordkeeping.</p>
            </div>
          </div>
          <p class="compliance-note">Note: OilChakra collects used cooking oil solely for conversion into non-food products. Oil handled by us is never sold back to any food business or reintroduced into the food chain — this is a firm policy, not just a claim.</p>
        </div>
      </section>

      <section class="section section-alt" id="coverage">
        <div class="wrap coverage-wrap">
          <div>
            <div class="eyebrow">Where We Operate</div>
            <h2 class="section-title">Currently collecting across the Dehradun region</h2>
            <p class="section-desc">Starting with Dehradun, expanding on the back of demand. If you're outside this list, reach out anyway — we're adding routes every quarter.</p>
          </div>
          <div class="coverage-list">
            <div class="coverage-item">Dehradun<span>Active</span></div>
          </div>
        </div>
      </section>

      <section class="section" id="contact">
        <div class="wrap">
          <div class="section-head">
            <div class="eyebrow">Get In Touch</div>
            <h2 class="section-title">Start a pickup, or start a supply line</h2>
          </div>
          <div class="contact-panel">
            <div class="contact-side">
              <h3>Talk to us directly</h3>
              <p>Fill the form, or reach out on any of these. We usually respond within a business day.</p>
              <div class="contact-detail"><b>Phone</b>+91 95288 99435</div>
              <div class="contact-detail"><b>Email</b>oilchakra26@gmail.com</div>
              <div class="contact-detail"><b>Base of operations</b>Dehradun, India</div>
            </div>
            <form onSubmit={handleSubmit} class="contact-form" id="leadForm">
              <div class="field">
                <label for="name">Name</label>
                <input value={form.name} name="name"
                  onChange={handleChange} type="text" id="name" required placeholder="Your full name" />
              </div>
              <div class="field">
                <label for="role">I am a</label>
                <select id="role" required name="type" value={form.type}
                  onChange={handleChange}>
                  <option value="">Select one</option>
                  <option>Restaurant / Hotel / Kitchen (want to sell UCO)</option>
                  <option>Biodiesel / Oleochemical unit (want to buy UCO)</option>
                  <option>Other / Not sure</option>
                </select>
              </div>
              <div class="field">
                <label for="phone">Phone or email</label>
                <input name="emailormobile" value={form.emailormobile}
                  onChange={handleChange} type="text" id="phone" required placeholder="How we reach you" />
              </div>
              <div class="field">
                <label for="message">Message</label>
                <textarea name="message" value={form.message}
                  onChange={handleChange} id="message" placeholder="Approx. volume, city, or anything else useful"></textarea>
              </div>
              <button type="submit" class="btn btn-primary" style={{ justifyContent: 'center', marginTop: '4px' }} disabled={loading}>
                {loading ? "Sending…" : "Send Enquiry ↗"}
              </button>
              {success && <div class="form-msg" id="formMsg">{success}</div>}
              {error && <div class="form-msg" id="formMsg">{error}</div>}
            </form>
          </div>
        </div>
      </section>

      <footer>
        <div class="wrap footer-row">
          <div class="logo" style={{ fontSize: '20px' }}><span class="mark" style={{ width: '22px', height: '22px', marginRight: '8px' }}></span><span class="l-oil">OIL</span><span class="l-chakra">CHAKRA</span></div>
          <p>© 2026 OilChakra Recovery. Used cooking oil collection & aggregation, Dehradun.</p>
        </div>
      </footer>
    </>
  );
}

export default App;
